export enum ContactPreference {
  PhoneCall,
  ViberCall,
  WhatsappCall,
}
